import { render, staticRenderFns } from "./SchemeCreate.vue?vue&type=template&id=a39c7d9c&"
import script from "./SchemeCreate.vue?vue&type=script&lang=js&"
export * from "./SchemeCreate.vue?vue&type=script&lang=js&"
import style0 from "./SchemeCreate.vue?vue&type=style&index=0&id=a39c7d9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports